var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_3500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 27.7061V30.625C0 33.0381 5.87891 35 13.125 35C20.3711 35 26.25 33.0381 26.25 30.625V27.7061C23.4268 29.6953 18.2656 30.625 13.125 30.625C7.98438 30.625 2.82324 29.6953 0 27.7061ZM21.875 8.75C29.1211 8.75 35 6.78809 35 4.375C35 1.96191 29.1211 0 21.875 0C14.6289 0 8.75 1.96191 8.75 4.375C8.75 6.78809 14.6289 8.75 21.875 8.75ZM0 20.5352V24.0625C0 26.4756 5.87891 28.4375 13.125 28.4375C20.3711 28.4375 26.25 26.4756 26.25 24.0625V20.5352C23.4268 22.8594 18.2588 24.0625 13.125 24.0625C7.99121 24.0625 2.82324 22.8594 0 20.5352ZM28.4375 21.2871C32.3545 20.5283 35 19.1201 35 17.5V14.5811C33.4141 15.7021 31.083 16.4678 28.4375 16.9395V21.2871ZM13.125 10.9375C5.87891 10.9375 0 13.3848 0 16.4062C0 19.4277 5.87891 21.875 13.125 21.875C20.3711 21.875 26.25 19.4277 26.25 16.4062C26.25 13.3848 20.3711 10.9375 13.125 10.9375ZM28.1162 14.7861C32.2178 14.0479 35 12.5986 35 10.9375V8.01855C32.5732 9.73438 28.4033 10.6572 24.0146 10.876C26.0312 11.8535 27.5146 13.166 28.1162 14.7861Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_3500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.431fc4db27fb714f6ba256b1e914d61a.svg";
export { ForwardRef as ReactComponent };